import type { SelectHTMLAttributes } from 'react';
import { ChevronDown } from './Icon';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps extends Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  'children'
> {
  label?: string;
  error?: string;
  placeholder?: string;
  options: SelectOption[];
}

/** Mesma forma do `Input` — ver `.field` em `styles/lp.css`. */
export function Select({
  label,
  error,
  placeholder,
  options,
  className = '',
  id,
  ...props
}: SelectProps) {
  return (
    <div className="field">
      {label && (
        <label htmlFor={id} className="field-label">
          {label}
        </label>
      )}

      <div className="field-control">
        <select
          id={id}
          className={`field-input has-action ${className}`}
          aria-invalid={!!error}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <ChevronDown size="sm" className="field-caret" />
      </div>

      {error && <p className="field-error">{error}</p>}
    </div>
  );
}
